let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8Gekp"), load("dXN7B")]).then(() => parcelRequire('lzjf5'));